import { AutoLoanCriteria } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';

export const vinFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.16,
    field: 'specs_identification_number',
    sortable: true,
    align: 'left',
    disableOnRowClick: true,
    headerName: <Text tId={'IDENTIFICATION_NUMBER'} />,
    renderCell: (rowData: { row: AutoLoanCriteria }) => {
      const vin = rowData.row.specsIdentificationNumber?.trim();

      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            lineHeight: 1.43,
            width: '100%',
          }}
        >
          <div className="shorted-cell simple-select overflow-text-ellipsis">{vin ? vin : '-'}</div>
        </div>
      );
    },
  };
};
